import React from 'react'

const CopyMailIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M4.66663 9.33333C4.29996 9.33333 3.98607 9.20278 3.72496 8.94167C3.46385 8.68056 3.33329 8.36667 3.33329 8V1.33333C3.33329 0.966667 3.46385 0.652778 3.72496 0.391667C3.98607 0.130556 4.29996 0 4.66663 0H14C14.3666 0 14.6805 0.130556 14.9416 0.391667C15.2027 0.652778 15.3333 0.966667 15.3333 1.33333V8C15.3333 8.36667 15.2027 8.68056 14.9416 8.94167C14.6805 9.20278 14.3666 9.33333 14 9.33333H4.66663ZM9.33329 6.2L4.66663 2.95V8H14V2.95L9.33329 6.2ZM9.33329 4.56667L14 1.33333H4.66663L9.33329 4.56667ZM1.99996 12C1.63329 12 1.3194 11.8694 1.05829 11.6083C0.797182 11.3472 0.666626 11.0333 0.666626 10.6667V2.33333H1.99996V10.6667H13V12H1.99996Z' />
    </svg>
  )
}

export default CopyMailIcon
